import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FolderPlus2 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.33594 4.02661C2.3359 3.88907 2.44726 3.7771 2.58598 3.7771H7.99623L9.42685 5.47219C9.56935 5.64104 9.77905 5.73846 10 5.73846H16.5C16.6381 5.73846 16.75 5.85039 16.75 5.98846V8C16.75 8.41421 17.0858 8.75 17.5 8.75C17.9142 8.75 18.25 8.41421 18.25 8V5.98846C18.25 5.02196 17.4665 4.23846 16.5 4.23846H10.3484L8.91781 2.54337C8.77531 2.37452 8.5656 2.2771 8.34466 2.2771H2.58598C1.61983 2.2771 0.835639 3.05975 0.835938 4.02708C0.83618 4.81253 0.836464 5.8972 0.836459 6.65867L0.836383 15C0.836368 16.5188 2.06759 17.75 3.58638 17.75H7.34466C7.75887 17.75 8.09466 17.4142 8.09466 17C8.09466 16.5858 7.75887 16.25 7.34466 16.25H3.58638C2.89602 16.25 2.33638 15.6903 2.33638 15L2.33646 6.65868C2.33646 5.89695 2.33618 4.81207 2.33594 4.02661ZM14.75 10C14.75 9.58579 14.4142 9.25 14 9.25C13.5858 9.25 13.25 9.58579 13.25 10L13.25 13.25H10C9.58579 13.25 9.25 13.5858 9.25 14C9.25 14.4142 9.58579 14.75 10 14.75H13.25L13.25 18C13.25 18.4142 13.5858 18.75 14 18.75C14.4142 18.75 14.75 18.4142 14.75 18L14.75 14.75H18C18.4142 14.75 18.75 14.4142 18.75 14C18.75 13.5858 18.4142 13.25 18 13.25H14.75L14.75 10Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default FolderPlus2
